const nodes = [].slice.call(document.querySelectorAll('.project-grid__item'), 0);
const directions  = { 0: 'top', 1: 'right', 2: 'bottom', 3: 'left' };
const classNames = ['in', 'out'].map((p) => Object.values(directions).map((d) => `${p}-${d}`)).reduce((a, b) => a.concat(b));

function getDirectionKey(event, node) {
  const { width, height, top, left } = node.getBoundingClientRect();
  const l = event.pageX - (left + window.scrollX);
  const t = event.pageY - (top + window.scrollY);
  const x = ((l - (width/2)) * (width > height ? (height/width) : 1));
  const y = ((t - (height/2)) * (height > width ? (width/height) : 1));
  return Math.round(Math.atan2(y, x) / 1.57079633 + 5) % 4;
}

class Item {
  constructor(element) {
    this.element = element;    
    this.element.addEventListener('mouseover', (event) => this.update(event, 'in'));
    this.element.addEventListener('mouseout', (event) => this.update(event, 'out'));
  }
  
  update(event, prefix) {
    this.element.classList.remove(...classNames);
    this.element.classList.add(`${prefix}-${directions[getDirectionKey(event, this.element)]}`);
  }
}

nodes.forEach(node => new Item(node));